import * as React from "react";

const STORAGE_KEY = "ht_tips_dismissed";

function getDismissed(): string[] {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
}

export function Tooltip({ id, children, tip }: { id: string; children: React.ReactNode; tip: string }) {
  const [visible, setVisible] = React.useState(() => !getDismissed().includes(id));

  const dismiss = () => {
    const arr = getDismissed();
    if (!arr.includes(id)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...arr, id]));
    setVisible(false);
  };

  return (
    <div className="relative h-full">
      {children}
      {visible && (
        <div className="absolute top-full left-0 mt-2 z-50 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg max-w-xs flex items-start gap-2">
          <span className="flex-1">{tip}</span>
          <button onClick={dismiss} className="text-gray-400 hover:text-white shrink-0">✕</button>
        </div>
      )}
    </div>
  );
}
